var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    { staticClass: "demo-ruleForm", attrs: { "label-width": "100px" } },
    [
      _c("el-form-item", { attrs: { label: "核销图片：" } }, [
        _c(
          "div",
          { staticClass: "avatar-uploader" },
          [
            _c(
              "el-upload",
              {
                staticClass: "upload-demo",
                attrs: {
                  action: "#",
                  "show-file-list": false,
                  "auto-upload": false,
                  "on-change": _vm.handleAvatarChange,
                },
              },
              [
                _vm.imageUrl
                  ? _c("img", {
                      staticClass: "avatar",
                      staticStyle: {
                        width: "100px",
                        height: "100px",
                        "border-radius": "50%",
                      },
                      attrs: { src: _vm.imageUrl },
                    })
                  : _c("div", { staticClass: "upLoadPicBox" }, [
                      _c("div", { staticClass: "upLoad" }, [
                        _c("i", {
                          staticClass: "el-icon-camera cameraIconfont",
                        }),
                      ]),
                    ]),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-form-item",
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", disabled: _vm.isDisabled },
              on: {
                click: function ($event) {
                  return _vm.submitForm()
                },
              },
            },
            [_vm._v("提交")]
          ),
          _vm._v(" "),
          _c("el-button", { on: { click: _vm.cancleEvent } }, [_vm._v("取消")]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }